import { createFileRoute } from "@tanstack/react-router";

import { denyRouteAccess } from "@/core/lib/route-access";

export const Route = createFileRoute("/_protected/report-issue/")({
  beforeLoad: ({ context, ...guard }) => {
    if (!context.appInfo.bug_reports) {
      denyRouteAccess(guard, "bug_reports_enabled");
    }
  },
});
